import { TextField, type TextFieldProps } from '@mui/material';
import type { FC } from 'react';
import { MAX_INTEGER_VALUE } from 'utils/numberUtils';

export type NumberTextFieldProps = Omit<TextFieldProps, 'type'>;

export const NumberTextField: FC<NumberTextFieldProps> = (props) => (
  <TextField
    {...props}
    type="number"
    inputProps={{ ...props.inputProps, max: MAX_INTEGER_VALUE }}
  />
);
